/** Kleine DOM-Helfer — Nutzdaten werden ausschließlich als Text gesetzt (XSS-sicher). */

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string> = {},
  text = '',
): HTMLElementTagNameMap[K] {
  const n = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (k === 'class') n.className = v;
    else n.setAttribute(k, v);
  }
  if (text) n.textContent = text;
  return n;
}

const eurFormat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
export const fmt = (v: number): string => eurFormat.format(v);

export const numFormat = (v: number): string => v.toLocaleString('de-DE');

/** Eingabewert → Zahl (deutsches Komma erlaubt); leere Eingabe → null */
export function parseNum(value: string): number | null {
  const t = value.trim().replace(',', '.');
  if (t === '') return null;
  const n = Number(t);
  return Number.isFinite(n) ? n : null;
}

export function clear(node: HTMLElement): void {
  node.replaceChildren();
}
